import { render, staticRenderFns } from "./eventDetailDialog.vue?vue&type=template&id=23bbd0b6"
import script from "./eventDetailDialog.vue?vue&type=script&lang=js"
export * from "./eventDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./eventDetailDialog.vue?vue&type=style&index=0&id=23bbd0b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports